import { render, staticRenderFns } from "./task-pre-call.vue?vue&type=template&id=674342ab&scoped=true&"
import script from "./task-pre-call.vue?vue&type=script&lang=js&"
export * from "./task-pre-call.vue?vue&type=script&lang=js&"
import style0 from "./task-pre-call.vue?vue&type=style&index=0&id=674342ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674342ab",
  null
  
)

export default component.exports